import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center" data-id="element-66">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-67">🧘‍♀️</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-68">
          About Yoga Ready
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-69">
          Our mission is clear: to give yoga teachers back their time and mental
          peace. We know what it's like to run from studio to studio and plan
          classes at 11 PM. Yoga Ready is the system we wish we had when we
          started.
        </p>
      </div>
    </section>;
}